import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-buttons" }
const _hoisted_2 = { class: "ml-2 text-sm" }

import { useUIStore } from "@/stores/loginDialog";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import { reactive, onMounted } from "vue";
import { Github_clientId } from "@/interface/globalindex";


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalLoginDialog',
  setup(__props) {

const uiStore = useUIStore();
const route = useRoute();

const { loginDialogVisible: visible } = storeToRefs(uiStore);

const handleClose = () => {
  userbutton.buttonText='通过 GitHub 登录'
  userbutton.btnshow = false
  uiStore.hideLoginDialog();
};

const userbutton = reactive({
    buttonText:'',
    btnshow: false
});

const logintip = reactive({
    githuboauth:'通过 GitHub 登录',
    redirect:'正在登录，等待跳转中...'
});

const handleGithubLogin = () => {
  // 生成随机state
  const state = Math.random().toString(36).substring(2, 15);
  // 保存当前路由
  localStorage.setItem("OAUTH_LOGIN_URL", route.fullPath);
  userbutton.buttonText = logintip.redirect
  userbutton.btnshow =  true;
  // 跳转到GitHub认证 
  window.location.href = `https://github.com/login/oauth/authorize?client_id=${Github_clientId}&state=${state}&allow_signup=true&scope=user:email`;
};

// const handleWechatLogin = () => {
//   // 微信登录逻辑
//   console.log("wechatlogin");
// };
onMounted(() => {
  userbutton.btnshow =  false;
  logintip.githuboauth = '通过 GitHub 登录';
  userbutton.buttonText = logintip.githuboauth
});


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "选择登录方式",
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: "15%",
    "before-close": handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 3 }),
            _createVNode(_component_el_col, { span: 18 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "default",
                  class: "github-btn",
                  disabled: userbutton.btnshow,
                  onClick: _withModifiers(handleGithubLogin, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _cache[1] || (_cache[1] = _createElementVNode("svg", {
                      t: "1745403273476",
                      class: "icon",
                      viewBox: "0 0 1024 1024",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "p-id": "6904",
                      width: "18",
                      height: "18"
                    }, [
                      _createElementVNode("path", {
                        d: "M512 85.333333C276.266667 85.333333 85.333333 276.266667 85.333333 512a426.410667 426.410667 0 0 0 291.754667 404.821333c21.333333 3.712 29.312-9.088 29.312-20.309333 0-10.112-0.554667-43.690667-0.554667-79.445333-107.178667 19.754667-134.912-26.112-143.445333-50.133334-4.821333-12.288-25.6-50.133333-43.733333-60.288-14.933333-7.978667-36.266667-27.733333-0.554667-28.245333 33.621333-0.554667 57.6 30.933333 65.621333 43.733333 38.4 64.512 99.754667 46.378667 124.245334 35.2 3.754667-27.733333 14.933333-46.378667 27.221333-57.045333-94.933333-10.666667-194.133333-47.488-194.133333-210.688 0-46.421333 16.512-84.778667 43.733333-114.688-4.266667-10.666667-19.2-54.4 4.266667-113.066667 0 0 35.712-11.178667 117.333333 43.776a395.946667 395.946667 0 0 1 106.666667-14.421333c36.266667 0 72.533333 4.778667 106.666666 14.378667 81.578667-55.466667 117.333333-43.690667 117.333334-43.690667 23.466667 58.666667 8.533333 102.4 4.266666 113.066667 27.178667 29.866667 43.733333 67.712 43.733334 114.645333 0 163.754667-99.712 200.021333-194.645334 210.688 15.445333 13.312 28.8 38.912 28.8 78.933333 0 57.045333-0.554667 102.912-0.554666 117.333334 0 11.178667 8.021333 24.490667 29.354666 20.224A427.349333 427.349333 0 0 0 938.666667 512c0-235.733333-190.933333-426.666667-426.666667-426.666667z",
                        fill: "#000000",
                        "p-id": "6905"
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(userbutton.buttonText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 3 })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})